import React from "react";
import GroupStudentSelector from "./GroupStudentSelector";
import CustomStudentSelector from "./CustomStudentSelector";
import { sortByKey } from "../../../global/sortByKey";

const StudentModeForm = ({
  mode,
  studentsState,
  groupOptions,
  customStudentOptions,
  serverGet,
  updateStudents,
}) => {
  if (studentsState.noStudentsAttending || studentsState.notYetConfirmed) {
    return null;
  }

  if (mode === "studentGroups") {
    return (
      <GroupStudentSelector
        selectedGroups={studentsState.selectedGroups}
        groupStudentsMap={studentsState.groupStudentsMap}
        studentMap={studentsState.studentMap}
        groupOptions={groupOptions}
        serverGet={serverGet}
        onUpdate={updateStudents}
      />
    );
  }

  if (mode === "customList") {
    console.log(sortByKey(customStudentOptions, "label"));
    return (
      <CustomStudentSelector
        customStudentOptions={customStudentOptions}
        selectedStudents={studentsState.customStudents}
        onAddCustomStudents={(selected) => {
          const rebuiltCustomList = [];
          const updatedStudentMap = { ...studentsState.studentMap };

          selected.forEach((option) => {
            const s = option.student || option;
            const stud_code = s.stCode || s.stud_code || s.value;
            const stYrLvl =
              s.stYrLvl ?? updatedStudentMap[stud_code]?.stYrLvl ?? null;

            const formattedName =
              s.stSurname && s.stPrfName
                ? `${s.stSurname}, ${s.stPrfName} (Yr ${
                    s.stYrLvl ?? stYrLvl
                  }, ${s.stHmrm || ""})`
                : s.stud_name || s.label || "Unknown student";

            if (!stud_code || !formattedName) return;

            rebuiltCustomList.push({ value: stud_code, label: formattedName });

            updatedStudentMap[stud_code] = {
              stud_code,
              stud_name: formattedName,
              stYrLvl,
            };
          });

          updateStudents({
            studentMap: updatedStudentMap,
            customStudents: rebuiltCustomList,
          });
        }}
      />
    );
  }

  return null;
};

export default StudentModeForm;
